
import React, { useState, useEffect, useRef } from "react";
// import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ImageWithBasePath from '../../core/img/imagewithbasebath';
import Axios from 'axios';
import { API_BASE_URL, GET_STOCK_TRANSFER_BY_ID } from "../../Config";
import {  useParams } from "react-router-dom";
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import 'jspdf-autotable';
import html2pdf from "html2pdf.js";
import logo from './41115.png';
import SpinLoader from "../loader/SpinLoader";



const ViewReceiveStockData = () => {

    const { OrgId, TransferId } = useParams();
    const [loading, setLoading] = useState(false);
    const [viewData, setViewData] = useState([]);
    const [firstData, setFirstData] = useState([]);
    const [formattedDate, setFormattedDate] = useState('');
    const contentRef = useRef(null);
    const [totalQty, setTotalQty] = useState("");
    // const [currentDate, setCurrentDate] = useState("");

    // const isMobile = window.innerWidth <= 768; 

    useEffect(() => {
        console.log("OrgId:", OrgId);
        console.log("TransferId:", TransferId);
    }, [OrgId, TransferId]);

    useEffect(() => {
        if (OrgId, TransferId){
            setLoading(true);
            const url = `${API_BASE_URL}${GET_STOCK_TRANSFER_BY_ID}?OrgId=${OrgId}&TransactionId=${TransferId}`;
            console.log(url)
            Axios.get(url)
                .then(response => {
                    if (response.data.Status) {
                        setViewData(response.data.ResultData);
                        setFirstData(response.data.ResultData[0]);
                        setLoading(false);
                        console.log(response.data.ResultData, 'req details');
                    } else {
                        console.error('Error fetching data:', response.data.Message);
                        setLoading(false);
                    }
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                    setLoading(false);
                });
        }
    
    }, [OrgId, TransferId]);

    // const renderTooltip = (props) => (
    //     <Tooltip id="pdf-tooltip" {...props}>
    //         Pdf
    //     </Tooltip>
    // );

    useEffect(() => {
        if (firstData) {
          if (firstData.TransferDate) {
            const poDate = new Date(firstData.TransferDate);
            const formattedPODate = poDate.toISOString().split("T")[0];
            setFormattedDate(formattedPODate);
          }
        }
      }, [firstData]);

      const [showPDF, setShowPDF] = useState(false);

      const generatePDF = () => {
        setShowPDF(true);
        const element = contentRef.current;
    
        html2pdf()
          .from(element)
          .save("purchase_order.pdf")
          .then(() => {
            setShowPDF(false);
          });
      };

    useEffect(() => {
        let totalQuantity = 0;
    
        if (viewData && viewData.length > 0) {

            totalQuantity = viewData.reduce((acc, product) => {
                const qty = product.ReqQuantity;
                return acc + (qty || 0);
            }, 0);
        }
    
        setTotalQty(totalQuantity);
    }, [viewData]);

    // useEffect(() => {
    //     const today = new Date();
    //     const month = String(today.getMonth() + 1).padStart(2, '0');
    //     const day = String(today.getDate()).padStart(2, '0');
    //     const year = today.getFullYear();
    
    //     const formattedDate = `${month}/${day}/${year}`;
    //     setCurrentDate(formattedDate);
    // })


    return (
        <div >
            {loading ? 
            // <div className="loader m-auto d-flex"></div> 
            <SpinLoader/>
            :
                <div className="container" style={{ width: "100%" , maxWidth: "800px" , margin: "0 auto" }}>
                    <div className="center-image" style={{ textAlign: "center" , margin: "10px" }}>
                        <img src={logo} alt="Purchase Order Image" style={{ width: "150px" , height: "auto" }} />
                    </div>
                    <hr />
            
                    <div className="d-flex" style={{ display: "flex" , justifyContent: "space-between" , alignItems: "flex-start" ,
                        flexWrap: "wrap" , gap: "20px" }}>
                        <h4 style={{ color: "#FF9F43" }}>RECEIVE STOCK</h4>
                        <div>
                            {/* <p >Date: {currentDate}</p> */}
                            <h4 className="text-info">
                                ST - {firstData?.AutoGenTransactionNo || ""}
                            </h4>
                        </div>
                        <div className="ms-auto me-5">
                            {showPDF ? <p>Downloading...</p> : 
                            <div onClick={generatePDF}>
                                <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                            </div>
                            }
                        </div>
                    </div>
            
                    <div className="vendor-ship" style={{ display: "flex" , justifyContent: "space-between" , flexWrap: "wrap" , marginBottom: "20px" , }}>
                        <div style={{ width: "100%" }}>
                            <p className="ship" style={{ color: "#FF9F43", fontWeight: "bold" , }}>
                                <h4 className="bg-primary text-white">TRANSFER DETAILS:</h4>
                            </p>
                            {/* <p>Supplier Name: {firstData?.SupplierName || ""}</p> */}
                            <p>To Store: {firstData?.ToStore || ""}</p>
                            <p>From Store: {firstData?.FromStore || ""}</p>
                            <p>Transfer Date: {formattedDate} </p>
                            <p>Status: {firstData?.Status || ""}</p>
                        </div>
                        <div style={{ width: "100%" }}>
                            <p className="mt-3" style={{ color: "#FF9F43",
                                fontWeight: "bold" , }}>
                                <h4 className="bg-primary text-white">SHIP TO:</h4>
                            </p>
                            <p>{firstData?.Notes || ""}</p>
                        </div>
                    </div>
            
                    <div className="table-responsive">
                        <table className="table" style={{ width: "100%", borderCollapse: "collapse", marginBottom: "15px" }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        #
                                    </th>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        Product
                                    </th>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        Req Qty
                                    </th>
                                    <th style={{ border: "1px solid #000", textAlign: "left", backgroundColor: "#FF9F43", color: "white" }}>
                                        Transfer Qty
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {viewData.map((item, index) => (
                                <tr key={index}>
                                    <td style={{ border: "1px solid #000" }}>{index + 1}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.ProductName}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.ReqQuantity}</td>
                                    <td style={{ border: "1px solid #000" }}>{item.TransferQty}</td>
                                </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <td colSpan="2" style={{ textAlign: "right", fontWeight: "bold" }}>Total Qty:</td>
                                    <td>{totalQty}</td>
                                    <td colSpan="1" style={{ textAlign: "right", fontWeight: "bold" }}>Total Amount:</td>
                                    {/* <td>{amountWithOutDis}</td> */}
                                </tr>
                            </tfoot>
                        </table>
                    </div>

                    <div className="comments col-12 col-md-6 mt-3" style={{ backgroundColor: "#f0f0f0" , padding: "10px" , }}>
                        <p>
                            <strong>Comments or Special Instructions:</strong>
                        </p>
                        <p>Thank you for your business.</p>
                    </div>
                    <div className="footer" style={{ fontSize: "12px" , textAlign: "center" , color: "gray" , marginTop: "20px" ,
                        }}>
                        <p>If you have any questions about this purchase order, please contact +91 1234567890</p>
                    </div>
                </div>
            }

                <div ref={contentRef} className={`container ${showPDF ? 'd-block' : 'd-none'}`} style={{ width: "100%" , maxWidth: "800px" , margin: "0 auto" }}>
                    <div className="center-image" style={{ textAlign: "center" , margin: "10px" }}>
                        <img src={logo} alt="Purchase Order Image" style={{ width: "150px" , height: "auto" }} />
                    </div>
                    <hr />
            
                    <div className="d-flex" style={{ display: "flex" , justifyContent: "space-between" , alignItems: "flex-start" ,
                        flexWrap: "wrap" , gap: "20px" , paddingLeft: "15px" , }}>
                        <h1 style={{ textAlign: "left" , color: "#FF9F43" }}>PURCHASE ORDER</h1>
                        <div>
                            {/* <p style={{ margin: 0 }}>Date: {currentDate}</p> */}
                            <h2 style={{ textAlign: "left" , color: "#FF9F43" , margin: 0 }}>
                                PO - {firstData?.AutoGenTransactionNo || ""}
                            </h2>
                        </div>
                    </div>
            
                    <div className="vendor-ship" style={{ display: "flex" , justifyContent: "space-between" , flexWrap: "wrap" , marginBottom: "20px" , }}>
                        <div style={{ width: "100%" }}>
                            <p className="ship" style={{ backgroundColor: "#FF9F43" , color: "white",
                                fontWeight: "bold" , }}>
                                <strong>TRANSFER DETAILS</strong>
                            </p>
                            {/* <p> Supplier Name: {firstData?.SupplierName || ""}</p> */}
                            <p>From Store: {firstData?.FromStore || ""}</p>
                            <p>To Store: {firstData?.ToStore || ""}</p>
                            <p>Transfer Date: {formattedDate} </p>
                            <p>Status: {firstData?.Status || ""}</p>
                            {/* <p>Discount: {firstData?.DiscountAmount || ""}</p> */}
                        </div>
                        <div style={{ width: "100%" }}>
                            <p className="mt-3" style={{ backgroundColor: "#FF9F43" , color: "white",
                                fontWeight: "bold" , }}>
                                <strong>SHIP TO</strong>
                            </p>
                            <p>{firstData?.Notes || ""}</p>
                        </div>
                    </div>
            
                    <div className="table-responsive">
                        <table className="table" style={{ width: "100%" , borderCollapse: "collapse" , marginBottom: "15px" , }}>
                            <thead>
                                <tr>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        #
                                    </th>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        Product
                                    </th>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        Req Qty
                                    </th>
                                    <th style={{ border: "1px solid", backgroundColor: "#FF9F43", textAlign: "left", color: "white" , }}>
                                        Transfer Qty
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {viewData.map((item, index) => (
                                    <tr key={item.index}>
                                        <td style={{ border: "1px solid #000"  }}>
                                            {index + 1}
                                        </td>
                                        <td style={{ border: "1px solid #000"  }}>
                                            {item.ProductName}
                                        </td>
                                        <td style={{ border: "1px solid #000"  }}>
                                            {item.ReqQuantity}
                                        </td>
                                        <td style={{ border: "1px solid #000"  }}>
                                            {item.TransferQty}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="comments col-12 col-md-6 mt-3" style={{ backgroundColor: "#f0f0f0" , padding: "10px" , }}>
                        <p>
                            <strong>Comments or Special Instructions:</strong>
                        </p>
                        <p>Thank you for your business.</p>
                    </div>
                    <div className="footer" style={{ fontSize: "12px" , textAlign: "center" , color: "gray" , marginTop: "20px" ,
                        }}>
                        <p>If you have any questions about this purchase order, please contact +91 9866954660</p>
                    </div>
                </div>
        </div>
      
    )
}



export default ViewReceiveStockData;
